<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="entitiesTable.additionalFilters"
                                    :default-sort="entitiesTable.defaultSort"
                                    :excel="true"
                                    :fields="entitiesTable.headers"
                                    :header-selection-key="'entities-headers'"
                                    :height="entitiesTable.height"
                                    :total-records="entitiesTable.total"
                                    :filter-save-key="'entities-filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in entitiesTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td
                                            v-if="entitiesTable.selectedHeaders.includes('id')"
                                            class="text-right"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="entitiesTable.selectedHeaders.includes('name')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            v-if="entitiesTable.selectedHeaders.includes('country_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.country_display }}
                                        </td>
                                        <td
                                            v-if="entitiesTable.selectedHeaders.includes('entity_type_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.entity_type_display }}
                                        </td>
                                        <td
                                            v-if="entitiesTable.selectedHeaders.includes('registration_date')"
                                            class="text-center"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.registration_date_display }}
                                        </td>
                                        <td
                                            v-if="entitiesTable.selectedHeaders.includes('active')"
                                            class="text-center"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.active" small>fa-check</v-icon>
                                            <v-icon v-else small>fa-minus</v-icon>
                                        </td>
                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Entities',
    components: {TheTable},
    data: function () {
        return {
            entitiesTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.id'), value: 'id', type: 'string', allowFilter: true, width: '10%'},
                    {text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.country'),
                        value: 'country_id',
                        type: 'dropdown|countries',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.type'),
                        value: 'entity_type_id',
                        type: 'dropdown|entity-types',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.dateCreated'), value: 'registration_date', type: ''},
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '140px',
                        allowFilter: true,
                    },
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [
                    {text: this.$t('fields.dateCreated'), value: 'registration_date', type: 'date_range'},
                ],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'name',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/entities/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/entities/' + id);
            } else {
                let routeData = this.$router.resolve('/entities/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.entitiesTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'entities', request, (data, success) => {
                if (success) {
                    vm.entitiesTable.items = data.items;
                    vm.entitiesTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'entities',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/entities', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.entitiesTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.entities'), href: '/#/entities', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resolveWindowResize);
    },
};
</script>

<style scoped></style>
